import { useSelector } from 'react-redux';
import { RootState } from 'src/shared/services/store';
import { createSignalRContext } from 'react-signalr';
import React from 'react';

interface Props {
  children: React.ReactNode;
}
export const SignalRContext = createSignalRContext();

export const useSignalRContext = () => {
  const context = SignalRContext;
  if (context === undefined) {
    throw new Error('useGlobals must be within AppContext');
  }
  return context;
};

export const SignalRProvider = ({ children }: Props) => {
  const user = useSelector((state: RootState) => state.oidc.user);
  return (
    <SignalRContext.Provider
      connectEnabled={!!user?.access_token}
      accessTokenFactory={() => user?.access_token ?? ''}
      dependencies={[user]} // remove previous connection and create a new connection if changed
      url={process.env.REACT_APP_HUB_ADDRESS ?? ''}
    >
      {children}
    </SignalRContext.Provider>
  );
};
